import React from 'react';



export default function ToBeStrategyMapEd() {

  return (
    <>
        <h1>THE TO-BE STRATEGY CANVAS</h1>
        <p>The To-Be Strategy Canvas is a visual analytic tool, which illustrates how your Blue Ocean Strategy is different from the current industry offering.</p>
        <img src={`${process.env.PUBLIC_URL}/images/5. to-Be-eng.jpg`} style={{width: 600}}/>
        <h3>
          Key elements of the To-Be Strategy Canvas::
        </h3>
        <p>
          1. Current and new key competition factors (horizontal axis).
        </p>

        <p>
          2. The offering level (vertical axis) shows what buyers receive across all of the key competition factors.
        </p>

        <p>
          3. A value curve or strategic profile is the graphic depiction of a company’s relative performance across its industry’s key competition factors.
        </p>
        <p>
          A value curve or strategic profile is the graphic depiction of a company’s relative performance across its industry’s key competition factors.
        </p>

        <h3>
          How to work with this instrument:
        </h3>

        <p>
          1. Evaluate competition factors from the Reduce-Eliminate-Raise-Create Grid using a point system from 1 to 5, where 1 means «low level of the offering», 5 means «high level of the offering».
        </p>
        <p>
          2. Place all the factors on the horizontal axis. Put the price first if you consider a commercial project. Then place all other factors that you eliminate, reduce, raise and, finally, create.
        </p>
        <p>
          3. Point the level of offerings across all key factors vertically, and, finally, connect the dots to visualize strategic profiles.
        </p>

        <h3>
          Rules:
        </h3>

        <p>
          1. All eliminated factors receive a rating of "0", the rest - on a scale of "high level" - "low level" in accordance with an raise or reduce in the level of the factor.
        </p>
        <p>
          2. Make sure your strategic profile is different from your competitor’s. It should not be the same or have a lot in common. Unless consumers will not see the difference between your product and the current industry offering.
        </p>
        <p>
          3. Make sure you focus on making a strategy that will provide value innovation for consumers and low costs for your company at the same time.
        </p>



    </>
  )
}
